// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SocialIcon_wrapper__l9m_8"};